"use strict";

import { addEvent } from "./addEvent/addEvent";
import { loadingEnd } from "./loading/loading";
import { mainPageBanerShow } from "./mainPageBaner/mainPageBaner";

addEvent(window, "load", function () {
  afterLoadStart();
});

function afterLoadStart() {
  loadingEnd(mainPageBanerShow);
}
